import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { changeEmail } from '../../store/actions/auth.action';
import { message } from 'antd';
import ROUTER from '../../routers/Routers';
import { useSearchParams } from 'react-router-dom';
import { openMessageSuccess } from '../../components/common/Message/openMessageSuccess';
import i18n from '../../languages/i18n';
import { useTranslation } from 'react-i18next';

const ConfirmedChangeEmail = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const new_email = searchParams.get('new_email');
  const token = searchParams.get('token');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(changeEmail({ token, new_email })).then(action => {
      if (action.payload?.data) {
        openMessageSuccess({ content: t('Email updated successfully') });
        navigate('/');
      } else navigate(ROUTER.LINK_EXPIRED);
    });
  }, []);
  return (
    <div className="flex items-center justify-center">
      <h2>{t('Processing email change')}</h2>
    </div>
  );
};

export default ConfirmedChangeEmail;
